import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { 
      main: "#1976d2",
      light: "#42a5f5",
      dark: "#1565c0" 
    },
    secondary: { 
      main: "#f50057",
      light: "#ff4081",
      dark: "#c51162" 
    },
    background: {
      default: "#f8f9fa",
      paper: "#ffffff"
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Arial',
      'sans-serif'
    ].join(','),
    h4: {
      fontWeight: 500
    },
    h5: {
      fontWeight: 500
    },
    h6: {
      fontWeight: 500
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
        },
        elevation1: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.7) !important",
            fontWeight: "500 !important",
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "collapse",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "8px",
          fontSize: "0.9rem",
        },
        head: {
          fontWeight: 600,
          backgroundColor: "rgba(25, 118, 210, 0.08)"
        }
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: "48px",
          "&:nth-of-type(even)": {
            backgroundColor: "rgba(0, 0, 0, 0.02)"
          },
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)"
          }
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: "40px",
          minHeight: "40px",
          fontSize: "0.9rem",
          padding: "8px 12px",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.9rem",
          padding: "8px 16px",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(25, 118, 210, 0.12)",
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.18)"
            }
          },
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)"
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4
        }
      }
    }
  },
});

export default theme;